/**
 * Hook personalizado para obtener sucursales desde el contexto
 * Los componentes deben usar este hook en lugar de llamar directamente a la API
 * El Sidebar es la única fuente de verdad para cargar sucursales
 */

import { useSucursal } from '@/context/SucursalContext';

export const useSucursalesFromContext = () => {
  const { 
    getSucursalesFromCache, 
    isCacheValid, 
    sucursalesCache,
    sucursalesCacheTimestamp 
  } = useSucursal();

  /**
   * Obtiene las sucursales desde el contexto
   * @returns {Array} Lista de sucursales o array vacío
   */
  const getSucursales = () => {
    return getSucursalesFromCache() || [];
  };

  /**
   * Verifica si hay datos disponibles y válidos
   * @returns {boolean} true si hay datos válidos
   */
  const hasValidData = () => {
    return isCacheValid() && sucursalesCache.length > 0;
  };

  /**
   * Obtiene información sobre el estado del cache
   * @returns {Object} Estado del cache
   */
  const getCacheInfo = () => {
    return {
      hasData: sucursalesCache.length > 0,
      isValid: isCacheValid(),
      timestamp: sucursalesCacheTimestamp,
      count: sucursalesCache.length
    };
  };

  return {
    sucursales: getSucursales(),
    hasValidData: hasValidData(),
    cacheInfo: getCacheInfo(),
    getSucursales,
    
    // Para debugging
    _raw: {
      cache: sucursalesCache,
      timestamp: sucursalesCacheTimestamp,
      isValid: isCacheValid()
    }
  };
};

export default useSucursalesFromContext;